export function getKeywords (data) {
    if (data && data !== '') {
        if (data.includes(', ')) {
            return data.split(', ');
        } else {
            return [data];
        }
    } else {
        return [];
    }
};